export default function cellPhoneMask(value = '') {
  const _digits = value.replace(/\D/g, '').slice(0, 11);
  const _match = _digits.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);
  return _match
    ? !_match[2] ? _match[1]
      : `(${_match[1]})${_match[2]}${_match[3] ? `-${_match[3]}` : ''}`
    : _digits;
}
